import React from 'react';
import BitPendingPopupNotification from './BitPendingPopupNotification';
import PaymentIssueNotification from './PaymentIssueNotification';
import UpdatePaymentBansData from './UpdatePaymentBansData';
import UpdatePaymentBansDetailsPopup from './UpdatePaymentBansDetailsPopup';
import BankNotInListPopup from './BankNotInListPopup';
import BankAccountMismatchPopup from './BankAccountMismatchPopup';
import SignatureRequiredPopup from './SignatureRequiredPopup';
import DebtFirstPopup from './DebtFirstPopup';
import DebtFirstPopupMax from './DebtFirstPopupMax';
import {popupEnum} from '../../Constants/debtPaymentEnum';
import {useDebtPaymentPopupData} from '../../hooks/useDebtPaymentPopupData';

const PopupWrapper = () => {
  const {popupData} = useDebtPaymentPopupData();

  let currentPopUp = () => {
    switch (popupData.popupType) {
      case popupEnum.BIT_PENDING:
        return <BitPendingPopupNotification />;
      case popupEnum.PAYMENT_METHOD_ISSUE:
        return <PaymentIssueNotification />;
      case popupEnum.UPDATE_ALL_CHECK_BOX:
        return <UpdatePaymentBansData />;
      case popupEnum.UPDATE_PAYMENT_BANS_DETAILS:
        return <UpdatePaymentBansDetailsPopup />;
      case popupEnum.BANK_NOT_IN_LIST:
        return <BankNotInListPopup />;
      case popupEnum.BANK_ACCOUNT_MISMATCH:
        return <BankAccountMismatchPopup props={popupData.popUpProps} />;
      case popupEnum.SIGNATURE_REQUIRED:
        return <SignatureRequiredPopup />;
      case popupEnum.DEBT_FIRST:
        return <DebtFirstPopup />;
      case popupEnum.DEBT_FIRST_MAX:
        return <DebtFirstPopupMax />;
      default:
        break;
    }
  };

  return <div>{currentPopUp()}</div>;
};

export default PopupWrapper;
